import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

/* user: null = checking session, false = signed out, object = signed in */
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        // CRITICAL: if returning from the Google OAuth redirect, skip the /me check.
        // AuthCallback exchanges the session_id and establishes the session first.
        if (window.location.hash?.includes("session_id=")) {
            return;
        }
        axios
            .get(`${API}/auth/me`, { withCredentials: true })
            .then((res) => setUser(res.data))
            .catch(() => setUser(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await axios.post(
            `${API}/auth/login`,
            { email, password },
            { withCredentials: true }
        );
        setUser(data);
        return data;
    };

    const register = async (name, email, password) => {
        const { data } = await axios.post(
            `${API}/auth/register`,
            { name, email, password },
            { withCredentials: true }
        );
        setUser(data);
        return data;
    };

    const logout = async () => {
        try {
            await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
        } finally {
            setUser(false);
        }
    };

    return (
        <AuthContext.Provider
            value={{ user, userLoading: user === null, login, register, logout }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
